import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ErrorService } from './error.service';

@Component({
  selector: 'wm-error-block',
  template: require('./error.component.html')
})

export class ErrorBlockComponent {
  error: Object;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private error_service: ErrorService
  ) {
    this.error_service.clearError();
    this.error_service.getError().subscribe(error => {
      console.log(error);
      if (!!error) {
        this.error = error;
      }
    });
  }
}
export class LinkErrorBlockComponent extends ErrorBlockComponent {}
export class CampaignErrorBlockComponent extends ErrorBlockComponent {}
export class CounterErrorBlockComponent extends ErrorBlockComponent {}
export class AgentErrorBlockComponent extends ErrorBlockComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/errors/error.component.ts